module.exports = __webpack_public_path__ + "img/ing-delivery-m.af44c93a.svg";